// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import api from "../../api/api";
// import getPermissionSlice from './permissionServices'

// const initialState = {
//     data: [],
//     isLoading: false,
//     isError : false,
//     isSuccess:false,
//     errorMessage: "",
// }


// export const permData = createAsyncThunk(
//     "users/permissions",
//     async (data, thunkAPI) => {
//         try {
//             return await getPermissionSlice.updatePermission(data)
//         }catch(error){
//             console.log(error.response);
//             const detail =
//               (error.response && error.response.data && error.response.data.data) ||
//               error.message ||
//               error.toString();
//             return thunkAPI.rejectWithValue(detail);
//         }
//     }
// )


// export const permissionSlice  = createSlice({
//     name: "permissions",
//     initialState,
//     reducers: {},
//     extraReducers: (builder) => {
//         builder
//         .addCase(permData.pending, (state)=> {
//             state.isLoading = true;
//         })
//         .addCase(permData.fulfilled, (state,action)=> {
//             state.isLoading = false;
//             state.isSuccess = true;
//             state.data = action.payload;
//         })
//         .addCase(permData.rejected, (state, action)=> {
//             state.isLoading = false;
//             state.isError = true;
//             state.errorMessage = action.payload
//         })
//     }
// })

// export default permissionSlice.reducer

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
import getPermissionSlice from "./permissionServices";
// import createUser from "./userBlockService";
// import getUser from "./userBlockService";

const initialState = {
  users: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  errorMessage: "",
};

export const permData = createAsyncThunk(
    "users/permissions",
    async (data, thunkAPI) => {
        try {
            return await getPermissionSlice.updatePermission(data)
        }catch(error){
            console.log(error.response);
            const detail =
              (error.response && error.response.data && error.response.data.data) ||
              error.message ||
              error.toString();
            return thunkAPI.rejectWithValue(detail);
        }
    }
)


export const permissionSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(permData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(permData.fulfilled, (state,action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.users = action.payload;
      })
      .addCase(permData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
  
  },
});

export default permissionSlice.reducer;
